import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({
    name: 'orderBy',
    pure: false,
    standalone: false
})
export class OrderByPipe implements PipeTransform {
  transform(array: Array<any>, args?: any, direction?: any): any {
    return _.orderBy(array, [args], direction);
  }
}
